import { useEffect } from "react";
import getConfig from "next/config";
import { getCookie } from "./Cookies";
import { COOKIE_NOTIFICATION_PERMISSION_SHOWN } from "./constants";

const { publicRuntimeConfig } = getConfig();

export const useOneSignal = () => {
  useEffect(() => {
    if (publicRuntimeConfig.ONESIGNAL_TOKEN) {
      window.OneSignal = window.OneSignal || [];
      OneSignal.push(function () {
        OneSignal.init({
          appId: publicRuntimeConfig.ONESIGNAL_TOKEN,
          safari_web_id: publicRuntimeConfig.SAFARI_WEB_ID,
          notifyButton: {
            enable: true,
          },
        });
      });

      return () => {
        window.OneSignal = undefined;
      };
    }
  }, []);
};

export const setExternalUserId = (externalUserId, hashId) => {
  if (publicRuntimeConfig.ONESIGNAL_TOKEN) {
    OneSignal.push(function () {
      OneSignal.setExternalUserId(externalUserId);
    });
  }
};

export const requestNotificationPermission = async (prompt, screenName) => {
  if(typeof window === 'undefined') return;
  
  if (!window.OneSignal) {
    window.OneSignal = window.OneSignal || [];
  }

  try {
    window.OneSignal.push(async function () {
      try {
              const cookieKey = `${COOKIE_NOTIFICATION_PERMISSION_SHOWN}_${screenName}`;
              getCookie().set(cookieKey, Date.now().toString(), {}, 365);

              // Check current permission status first
              const permission = await window.OneSignal.getNotificationPermission();
              if (permission === "granted") {
                  return;
              }
              const userConfirmed = window.confirm(`${prompt.title}\n\n${prompt.text}`);
              if (userConfirmed) {
                  try {
                      await window.OneSignal.showNativePrompt();
                  } catch (error) {
                      console.error("Error requesting notification permission:", error);
                  }
              }


          } catch (error) {
              console.error("Error in OneSignal callback:", error);
          }
      });
  } catch (error) {
      console.error("Error in requestNotificationPermission:", error);
  }
};

export const shouldShowPrompt = (prompt, screenName) => {
  if (prompt.screen_name !== screenName) return false;

  const cookieKey = `${COOKIE_NOTIFICATION_PERMISSION_SHOWN}_${screenName}`;
  const lastShown = getCookie().get(cookieKey);

  if (!lastShown) return true;

  const timeSinceLastShown = Date.now() - parseInt(lastShown);
  return timeSinceLastShown > (prompt.frequency * 1000);
};